import apiClient from './api'
import { normalizaTelefoneBR } from './financeiro'

export const RESTRICOES_OPCOES = [
  { value: 'Vegetariano', label: 'Vegetariano' },
  { value: 'Vegano', label: 'Vegano' },
  { value: 'Sem lactose', label: 'Sem lactose' },
  { value: 'Sem glúten', label: 'Sem glúten' }
]

export async function getInscricao(id) {
  const { data } = await apiClient.get(`/inscricao/${encodeURIComponent(id)}`)
  return data
}

export async function submitInscricao(id, payload) {
  const { data } = await apiClient.post(`/inscricao/${encodeURIComponent(id)}`, payload)
  return data
}

export function buildPublicLink(id) {
  const base = process.env.VUE_APP_PUBLIC_URL
    || (typeof window !== 'undefined' ? window.location.origin : '')
  return `${base}/inscricao/${id}`
}

export function buildSuporteWaLink(suporteContato, nome) {
  const phone = normalizaTelefoneBR(suporteContato)
  if (!phone) return null
  const msg = `Olá! Preciso alterar minha ficha de inscrição do Acamp. Meu nome é ${nome || ''}.`
  return `https://wa.me/${phone}?text=${encodeURIComponent(msg.trim())}`
}

export function buildMensagemConvite(acampante) {
  const primeiroNome = (acampante?.name || '').split(' ')[0] || ''
  const link = buildPublicLink(acampante?.id)
  return (
    `Oi ${primeiroNome}! 👋\n\n` +
    `Pra finalizar sua inscrição no *Acamp El Shaday*, precisamos que você preencha sua ficha ` +
    `(acomodação, transporte, alergias, restrição alimentar e contato de emergência). ` +
    `É *obrigatório* pra liberar a sua entrada no acamp.\n\n` +
    `👉 Acessa aqui: ${link}\n\n` +
    `Este link é *único e individual*. Depois de enviar, você recebe o seu *QR Code* de check-in pra apresentar no portão. ` +
    `Qualquer dúvida me chama. 🙏`
  )
}

export function buildConviteWhatsAppLink(acampante) {
  const phone = normalizaTelefoneBR(acampante?.contato)
  if (!phone) return null
  const msg = encodeURIComponent(buildMensagemConvite(acampante))
  return `https://wa.me/${phone}?text=${msg}`
}

export function parseRestricoes(csv) {
  if (!csv) return { chips: [], outro: '' }
  const parts = String(csv).split(',').map(s => s.trim()).filter(Boolean)
  const knownValues = RESTRICOES_OPCOES.map(o => o.value)
  const chips = parts.filter(p => knownValues.includes(p))
  const outroParts = parts.filter(p => !knownValues.includes(p))
  return { chips, outro: outroParts.join(', ') }
}

export function serializeRestricoes(chips, outro) {
  const list = [...(chips || [])]
  const trimmedOutro = (outro || '').trim()
  if (trimmedOutro) list.push(trimmedOutro)
  return list.length ? list.join(', ') : null
}
